<div class="container" *ngIf="!isUnidad; else unidad">
    <!--<div class="userMenuChip">-->
    <!--<mat-icon *ngIf="!userImage" class="userMenuChip__ico">account_circle</mat-icon>-->
    <!--<img *ngIf="userImage" #userPic src="{{alumno.imageUrl}}" class="userMenuChip__img">-->
    <!--<div>-->
    <!--<span class="userMenuChip__user">{{alumno.nombresApellidos}}</span>-->
    <!--<span class="userMenuChip__otherInfo">{{alumno.eMail}}</span>-->
    <!--</div>-->
    <!--</div>-->
    <!--<div class="alumnoFicha__content">-->
    <!--<p><strong>Curso:</strong> {{alumno.curso.nickName}}</p>-->
    <!--</div>-->
    <user-card *ngIf="alumno" [persona]="alumno"></user-card>
    <div class="alumnoMaterias">
        <router-outlet></router-outlet>
    </div>
</div>
<ng-template #unidad>
    <router-outlet></router-outlet>
</ng-template>
